export const computeScores = (answer, batches) => {
  let scores = null

  if (answer?.meanStat != null) {
    const pair = [answer.meanStat.min, answer.meanStat.max].filter(v => v != null)
    if (pair.length === 2) scores = pair
  }

  if (!scores) {
    scores = batches[0].answerVariants.map((a, i) => a.score || 10 * (i + 1))
  }

  return [...scores].sort((a, b) => a - b)
}

export const computeRadius = (scores, chartWidth, formatSize) => {
  if (formatSize) return formatSize
  const range = scores[scores.length - 1] - scores[0]
  return (10 * range) / chartWidth || 0.3
}
